/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedClassStudentList200,
  GetApiV1CourseregistrationSharedClassStudentList401,
  GetApiV1CourseregistrationSharedClassStudentList500,
  GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedClassStudentList.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1CourseregistrationSharedClassStudentListQueryParamsSchema =
  z.object({
    filter: z.optional(z.string()),
    courseId: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
    mainOnly: z.boolean().default(false),
    monographOnly: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedClassStudentListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedClassStudentList200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedClassStudentList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedClassStudentList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedClassStudentList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedClassStudentList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedClassStudentList500>;

export const getApiV1CourseregistrationSharedClassStudentListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedClassStudentList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedClassStudentListQueryResponse>;
